import { useState } from "react";
import { getUserInfo } from "services/authService";
import userImage from "../assets/images/home-decor-1.jpg";
// font-awesome
import "@fortawesome/fontawesome-free/css/all.min.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faUser } from "@fortawesome/free-solid-svg-icons";
import MDButton from "components/MDButton";
import ResetPassword from "layouts/super_admin/admin/modals/ResetPassword";
import { useTranslation } from "hooks/useTranslation";
import { getRoleLabel } from "utils/roleLabels";

function UserProfile() {
  const { t } = useTranslation();
  const user = getUserInfo();
  const [openResetPassword, setOpenResetPassword] = useState(false);

  if (!user) return null;

  const handleResetPasswordOpen = () => {
    setOpenResetPassword(true);
  };

  const handleResetPasswordClose = () => {
    setOpenResetPassword(false);
  };

  return (
    <>
      <div style={{ padding: "10px", color: "white" }}>
        <div style={{ display: "flex", alignItems: "center", gap: "6" }}>
          <FontAwesomeIcon icon={faUser} fontSize="large" />
          {/* <img
          src={userImage} // or use MUI Avatar component
          alt="avatar"
          style={{
            width: 40,
            height: 40,
            borderRadius: "50%",
            marginRight: 10,
          }}
        /> */}
          <div style={{ marginLeft: "10px" }}>
            <div style={{ fontWeight: "bold", fontSize: "medium" }}>{user.full_name}</div>
            <div style={{ fontSize: "12px", textTransform: "uppercase" }}>
              {getRoleLabel(user.role, t)}
            </div>
          </div>
        </div>
        {user.role === "SuperAdmin" && (
          <MDButton
            variant="outlined"
            color="white"
            size="small"
            onClick={handleResetPasswordOpen}
            fullWidth
            sx={{
              mt: 2,
              whiteSpace: "normal",
              lineHeight: 1.4,
              fontSize: "0.75rem",
              py: 0.8,
            }}
          >
            {t("superAdmin.table.actions.resetPassword", "Reset Password")}
          </MDButton>
        )}
      </div>
      {user.role === "SuperAdmin" && (
        <ResetPassword
          open={openResetPassword}
          onClose={handleResetPasswordClose}
          user={user}
          onSuccess={() => {
            console.log("Password reset successfully");
          }}
        />
      )}
    </>
  );
}
export default UserProfile;
